"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseInfoModel = void 0;
const AddressModel_1 = require("./AddressModel");
const ContactInfoModel_1 = require("./ContactInfoModel");
const HoursOfOperationModel_1 = require("./HoursOfOperationModel");
const StorageDetailsModel_1 = require("./StorageDetailsModel");
const WarehouseInfoModel = {
    type: Array,
    items: {
        type: Object,
        schema: {
            id: { type: String, required: true, unique: true },
            name: { type: String },
            editStatus: { type: String },
            description: { type: String },
            address: AddressModel_1.AddressModel,
            contact: ContactInfoModel_1.ContactInfoModel,
            videoUrl: { type: String },
            videoDescription: { type: String },
            hubspotRowId: { type: String },
            images: {
                type: Array,
                items: {
                    type: Object,
                    schema: {
                        url: { type: String },
                        caption: { type: String },
                    },
                },
            },
            capabilities: {
                type: Array,
                items: {
                    type: String,
                },
            },
            hoursOfOperation: HoursOfOperationModel_1.HoursOfOperationModel,
            storage: {
                type: Object,
                schema: {
                    rack: { type: Array, items: StorageDetailsModel_1.StorageDetailsModel },
                    bin: { type: Array, items: StorageDetailsModel_1.StorageDetailsModel },
                    buildingDetails: {
                        type: Object,
                        schema: {
                            warehouseSize: { type: Number },
                            numberOfPallets: { type: Number },
                        },
                    },
                },
            },
            operations: {
                type: Object,
                schema: {
                    whManagementSystem: {
                        type: Object,
                        schema: {
                            technology: { type: String },
                            capabilities: {
                                type: Array,
                                items: {
                                    type: String,
                                },
                            },
                        },
                    },
                    buildingSpecifications: {
                        type: Array,
                        items: {
                            type: String,
                        },
                    },
                    docking: {
                        type: Object,
                        schema: {
                            dockDoors: { type: Number },
                            height: { type: Number },
                        },
                    },
                    certifications: {
                        type: Array,
                        items: {
                            type: String,
                        },
                    },
                },
            },
        },
    },
};
exports.WarehouseInfoModel = WarehouseInfoModel;
